import { useIOStore } from '../stores/io'

// This should be used an a layer seperately

export default defineNuxtPlugin({
  name: 'io-store-setup',
  // Use a lower order to ensure this plugin loads before other plugins
  order: 10,
  setup(nuxtApp) {
    const ioStore = useIOStore()
    return {
      provide: {
        io: ioStore,
      },
    }
  }
})
